import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { rem, transparentize } from "polished";
import React from "react";
import { useRecoilValue } from "recoil";

import { Box, pickColor } from "../../base";
import { appDataAtom } from "../../modules/apps";

export interface SearchProps {
  active?: boolean;
}

export const SearchContainer = styled(Box)<SearchProps>`
  position: relative;
  z-index: 20;
  width: 100%;
  padding: 0;

  /* background: #ffffff; */
  border-radius: ${rem(14)};
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0px ${rem(1)} ${rem(3)}
    ${(props) =>
      props.theme.color &&
      pickColor(props, transparentize(0.6, props.theme.color?.mid))};

  opacity: 0.6;

  transition: box-shadow 0.1s, opacity 0.1s;
  cursor: pointer;

  &:hover {
    opacity: 1;
    box-shadow: 0px ${rem(2)} ${rem(8)}
      ${(props) =>
        props.theme.color &&
        pickColor(props, transparentize(0.6, props.theme.color?.mid))};
  }

  ${(props) =>
    props.active &&
    css`
      opacity: 1;
      box-shadow: 0px ${rem(2)} ${rem(8)}
        ${props.theme.color &&
        pickColor(props, transparentize(0.6, props.theme.color?.mid))};
    `}
`;

export const SearchSection = styled.section``;

export const Input = styled.input`
  outline: none;
  border: none;
  border-radius: ${rem(14)};

  width: 100%;

  font-size: ${rem(24)};
  font-weight: 500;
  line-height: 1.5;

  color: ${({ theme }) => theme.color?.mid};
`;

const StyledTag = styled.div<any>`
  padding: ${rem(6)} ${rem(10)};
  margin: 0 ${rem(4)};

  font-size: ${rem(20)};
  font-weight: 500;

  color: ${(props) =>
    props.selected ? "#fff" : pickColor(props, props.theme.color?.mid)};
  border-radius: ${rem(8)};
  background: ${(props) =>
    props.selected
      ? `linear-gradient(91.06deg, ${props.theme.color.start} 0.06%, ${props.theme.color.end} 99.98%)`
      : transparentize(0.9, pickColor(props, props.theme.color?.mid))};
  border: 1px solid
    ${(props) =>
      props.selected
        ? "transparent"
        : transparentize(0.6, pickColor(props, props.theme.color?.mid))};
`;

export const SearchTag = ({ type, slug = "", ...props }) => {
  const apps = useRecoilValue(appDataAtom);

  let color;
  let label = slug;
  if (type === "app" || type === "transformer") {
    const app = apps.find((app) => app.slug === slug);
    label = app?.name ?? slug;
    color = app?.color;
  }
  return (
    <StyledTag color={color} {...props}>
      {label}
    </StyledTag>
  );
};
